import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import { RichTextTile } from 'components/no-auth/common/RichTextTile/RichTextTile';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const ProhibitedActivitiesPage = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell03">
            {props.heroTitle && <HeroSection title={props.heroTitle} data={props.heroData} />}
            <PromoSectionContainer dimension="average">{props.content && <RichTextTile text={props.content} />}</PromoSectionContainer>
        </PromoPageContainer>
    );
};

ProhibitedActivitiesPage.propTypes = {
    heroTitle: PropTypes.string,
    heroData: PropTypes.object,
    content: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroData: state.extra?.strapiApi?.hero_block,
        content: state.extra?.strapiApi?.content,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(ProhibitedActivitiesPage));
